<div class="itinerary-detail-loading">
	<div class="itinerary-detail-loading-inner content-placeholder">
		<svg height="0" width="0">
			<defs>
				<clipPath id="svg-placeholder">
					<rect height="20" rx="4" ry="4" width="90" x="0" y="0"></rect>
					<rect height="22" rx="4" ry="4" width="140" x="0" y="45"></rect>
					<rect height="22" rx="4" ry="4" widFth="60" x="0" y="97"></rect>
					<rect height="17" rx="4" ry="4" width="40" x="260" y="89"></rect>
					<rect height="16" rx="4" ry="4" width="140" x="250" y="110"></rect>
					<rect height="17" rx="4" ry="4" width="60" x="0" y="145"></rect>
					<rect height="17" rx="4" ry="4" width="60" x="250" y="145"></rect>
					<rect height="17" rx="4" ry="4" width="70" x="0" y="164"></rect>
					<rect height="17" rx="4" ry="4" width="70" x="230" y="164"></rect>
					<rect height="22" rx="4" ry="4" width="83" x="0" y="183"></rect>
					<rect height="22" rx="4" ry="4" width="110" x="222" y="183"></rect>
					<rect height="19" rx="4" ry="4" width="40" x="0" y="227"></rect>
					<rect height="19" rx="4" ry="4" width="40" x="257" y="227"></rect>
					<rect height="15" rx="4" ry="4" width="35" x="0" y="248"></rect>
					<rect height="15" rx="4" ry="4" width="40" x="257" y="248"></rect>
					<rect height="25" rx="4" ry="4" width="138" x="0" y="274"></rect>
					<rect height="25" rx="4" ry="4" width="110" x="187" y="274"></rect>
					<rect height="17" rx="4" ry="4" width="92" x="0" y="320"></rect>
				</clipPath>
			</defs>
		</svg>
	</div>
</div>
